import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {TokenDto} from '../common/dtos/tokenDto';
import {switchMap} from 'rxjs/operators';
import {TokenService} from './token.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient, private tokenService: TokenService) {
  }

  exchangeToken(code: string): Observable<TokenDto> {
    return this.http.get<TokenDto>(`/api/user/token?code=${code}`)
    .pipe(
      switchMap(dto => {
        this.tokenService.setRefresh(dto.refresh);
        this.tokenService.setToken(dto.token);
        this.tokenService.isLoggedIn.next(true);
        return of(dto);
      })
    );
  }
}
